import { render, staticRenderFns } from "./AttemptWrong.vue?vue&type=template&id=74281a36&scoped=true&"
import script from "./AttemptWrong.vue?vue&type=script&lang=js&"
export * from "./AttemptWrong.vue?vue&type=script&lang=js&"
import style0 from "./AttemptWrong.vue?vue&type=style&index=0&id=74281a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74281a36",
  null
  
)

component.options.__file = "AttemptWrong.vue"
export default component.exports